import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";
import { filterParams } from "../Utils/helpers";

export const getVehicleRequests = (
  page,
  perPage,
  search_string,
  status,
  from,
  to,
  sortField = "createdAt",
  sortOrder = "desc"
) => {
  const skip = (page - 1) * perPage;
  const dir = sortOrder === "asc" ? 1 : -1;
  const key = sortField && String(sortField).trim();
  const sortObj = key ? { [key]: dir } : { createdAt: -1 };
  return api.get(`${adminV1Base}/vehicle/get-vehicle`, {
    params: filterParams({
      skip,
      limit: perPage,
      status,
      sort: JSON.stringify(sortObj),
      keyword: search_string,
      "createdAt[from]": from,
      "createdAt[to]": to,
    }),
  });
};

export const getVehicleRequestDetails = (id) => {
  return api.get(`${adminV1Base}/vehicle/get-vehicle`, {
    params: filterParams({
      _id: id,
    }),
  });
};

export const changeVehicleRequestStatus = (id, data) => {
  return api.post(`${adminV1Base}/vehicle/handle-request/${id}`, data);
};
